import styled from 'styled-components';

export const StyledContainer = styled.div`
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    background-color: ${({ theme }) => theme.white};
    box-sizing: border-box;
    border-radius: 1rem;
    margin-bottom: 3rem;
    transition: 0.1s;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    overflow: visible !important;
`;

export const StyledLabel = styled.h3`
    font-weight: 500;
`;

export const StyledHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 2rem;
`;

export const StyledSelect = styled.select`
    margin-left: 5px;
    padding-right: 40px;
`;

export const StyledLabelNoData = styled.div`
    padding: 10px;
    margin-top: 10px;
`;
